
/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator'

import RallyRoundStatusTable from '@/components/statistics/RallyRoundStatusTable.vue'
import LastCustomerRegister from '@/components/statistics/LastCustomerRegister.vue'
import RodeoPieChart from '@/components/statistics/RodeoPieChart.vue'
import { Http } from '@/lib/utils/Http'

@Component({
  components: {
    RallyRoundStatusTable,
    LastCustomerRegister,
    RodeoPieChart
  }
})
export default class RegisterStats extends Vue {
    statisticData = []

    get activeStatisticDataByVehicle () {
      const states = [
        'registered',
        'paid',
        'finished',
        'available',
        'waiting',
        'cancelled'
      ]
      const activeStatisticsDataByVehicle: any[] = []
      this.activeStatisticData.forEach((statisticElement: any) => {
        if (statisticElement.max_teams_1) {
          const carStatistics = { ...statisticElement }
          states.forEach(state => {
            carStatistics[state + '_bikes'] = 0
            carStatistics[state + '_boats'] = 0
          })
          carStatistics.max_teams_2 = 0
          carStatistics.max_teams_3 = 0
          carStatistics.name = statisticElement.name + ' Autos'
          activeStatisticsDataByVehicle.push(carStatistics)
        }
        if (statisticElement.max_teams_2) {
          const bikeStatistics = { ...statisticElement }
          states.forEach(state => {
            bikeStatistics[state + '_cars'] = 0
            bikeStatistics[state + '_boats'] = 0
          })
          bikeStatistics.name = statisticElement.name + ' Bikes'
          bikeStatistics.max_teams_1 = 0
          bikeStatistics.max_teams_3 = 0
          activeStatisticsDataByVehicle.push(bikeStatistics)
        }
        if (statisticElement.max_teams_3) {
          const boatStatistics = { ...statisticElement }
          states.forEach(state => {
            boatStatistics[state + '_cars'] = 0
            boatStatistics[state + '_bikes'] = 0
          })
          boatStatistics.name = statisticElement.name + ' Boote'
          boatStatistics.max_teams_1 = 0
          boatStatistics.max_teams_2 = 0
          activeStatisticsDataByVehicle.push(boatStatistics)
        }
      })
      return activeStatisticsDataByVehicle
    }

    get activeStatisticData () {
      return this.statisticData.filter((data: any) => { return data.aktiv })
    }

    get inactiveStatisticData () {
      return this.statisticData.filter((data: any) => { return !data.aktiv })
    }

    mounted () {
      this.loadData()
      setInterval(this.loadData, 10000)
    }

    private async loadData () {
      const res = await Http.request('/api/statistic/register')
      if (res.status !== 200) {
        window.location.replace('/teamarea/login.php')
      } else {
        this.statisticData = await res.json()
      }
    }
}
